import { Controller } from "react-hook-form";
import {  MenuItem, TextField } from "@mui/material";

type Props = {
  control: any;
  name: string;
  label: string;
  defaultValue?: any;
  errors: any;
  placeholder?: string;
  rules: any;
  options: any;
};

const SelectInput = ({ control, name, label, defaultValue = "", errors, placeholder = "", rules, options } : Props) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field }) => (
        <TextField
          key="username"
          variant="outlined"
          label={label}
          size="small"
          fullWidth
          select
          className="mb-3"
          placeholder={placeholder}
          {...field}
          error={errors[name] && true}
          helperText={
            errors[name] && (errors[name].message as string)
          }
        >
          {options.map((option) => (
            <MenuItem key={option.code} value={option.code}>
              {option.name}
            </MenuItem>
          ))}
          </TextField>
      )}
    />
  );
};

export default SelectInput;
